module.exports = "../images/fishing-lodge-3-25.jpg?v=b70b0bf";